import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { URLs } from 'src/environments/constants';
import { Response_Forms } from 'src/app/Interfaces/Forms/FormTemplate.interface';

@Injectable({
  providedIn: 'root'
})
export class FormTemplateService {

  http = inject(HttpClient);
  public GeneralURL = URLs.FORMS_SERVICE;

  // ======================== FORM TEMPLATES ========================

  GetAllFormTemplates(Status?: number, Category?: string): Observable<Response_Forms> {
    let params: any = {};
    if (Status) params.Status = Status;
    if (Category) params.Category = Category;
    return this.http.get<Response_Forms>(`${this.GeneralURL}/Templates`, { params });
  }

  GetFormTemplateById(id: number): Observable<Response_Forms> {
    return this.http.get<Response_Forms>(`${this.GeneralURL}/Templates/${id}`);
  }

  CreateFormTemplate(data: any): Observable<Response_Forms> {
    return this.http.post<Response_Forms>(`${this.GeneralURL}/Templates`, data);
  }

  UpdateFormTemplate(id: number, data: any): Observable<Response_Forms> {
    return this.http.put<Response_Forms>(`${this.GeneralURL}/Templates/${id}`, data);
  }

  ChangeStatusFormTemplate(id: number, Status: number): Observable<Response_Forms> {
    return this.http.patch<Response_Forms>(`${this.GeneralURL}/Templates/${id}/Status`, { Status });
  }

  GetFormTemplateVersions(id: number): Observable<Response_Forms> {
    return this.http.get<Response_Forms>(`${this.GeneralURL}/Templates/${id}/Versions`);
  }

  DuplicateFormTemplate(id: number): Observable<Response_Forms> {
    return this.http.post<Response_Forms>(`${this.GeneralURL}/Templates/${id}/Duplicate`, {});
  }

  // ======================== FORM SUBMISSIONS ========================

  CreateSubmission(data: any): Observable<Response_Forms> {
    return this.http.post<Response_Forms>(`${this.GeneralURL}/Submissions`, data);
  }

  GetSubmissionByWorkflow(workflowId: number, Library: string = 'FIN'): Observable<Response_Forms> {
    return this.http.get<Response_Forms>(`${this.GeneralURL}/Submissions/${workflowId}`, { params: { Library } });
  }

  UpdateSubmission(id: number, data: any): Observable<Response_Forms> {
    return this.http.put<Response_Forms>(`${this.GeneralURL}/Submissions/${id}`, data);
  }

  // ======================== PDF GENERATION ========================

  GeneratePDF(data: { ID_Form_Template: number, Values: any[], Code: string, Purpose: string }): Observable<Blob> {
    return this.http.post(`${this.GeneralURL}/Submissions/GeneratePDF`, data, { responseType: 'blob' as 'json' }) as Observable<Blob>;
  }

  // ======================== REPORTS ========================

  GetReportsOverview(days: number = 30): Observable<Response_Forms> {
    return this.http.get<Response_Forms>(`${this.GeneralURL}/Reports/Overview`, { params: { days } });
  }

  GetFieldStatistics(templateId: number, dateFrom?: string, dateTo?: string): Observable<Response_Forms> {
    const params: any = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    return this.http.get<Response_Forms>(`${this.GeneralURL}/Reports/Fields/${templateId}`, { params });
  }

  // ======================== GENAI ========================

  GenAIChat(prompt: string, currentSchema: any, chatHistory: any[], file?: File): Observable<Response_Forms> {
    const formData = new FormData();
    formData.append('prompt', prompt);
    formData.append('currentSchema', JSON.stringify(currentSchema));
    formData.append('chatHistory', JSON.stringify(chatHistory));
    if (file) {
      formData.append('file', file);
    }
    return this.http.post<Response_Forms>(`${this.GeneralURL}/GenAI/Chat`, formData);
  }
}
